import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  Input,
  Button,
} from "reactstrap";
// service
import {
  getConfigQuota,
  changeConfigQuota,
} from "../../../utils/services/quotas";
import { getUrlFiles } from "../../../utils/services/files";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// componentes
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

export default function ModalConfigSiteQuota(props) {
  const { isOpen, toggle, jwt, eventId } = props;
  const [isLoading, setIsloading] = useState(false);

  // dados do form
  const [color, setColor] = useState("#007CB6");
  const [img, setImg] = useState(null);
  const [imgUrl, setImgUrl] = useState(null);
  const [description, setDescription] = useState(false);
  const [localization, setLocalization] = useState(false);
  const [idConfigQuota, setIdConfigQuota] = useState(null);
  const [minQuota, setMinQuota] = useState(1);
  const [maxQuota, setMaxQuota] = useState(4);
  // tipo de requisição
  const [typeRequets, setTypeRequets] = useState("post");
  // alerta
  const [success, setSuccess] = useState(false);
  // erros
  const [imgError, setImgError] = useState("");
  // carregamento
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);

  async function submitForm() {
    if (!img && !imgUrl) {
      setImgError("A imagem do evento é obrigatório");
      return;
    } else setImgError("");

    var urlImg = null;

    if (!img && imgUrl) {
      urlImg = imgUrl;
    } else {
      var imgDoc = new FormData();

      imgDoc.append("files", img.target.files[0]);

      await getUrlFiles(imgDoc, jwt).then((res) => {
        urlImg = res[0].url;
      });
    }

    const data = {
      eventId: eventId,
      image: urlImg,
      color: color,
      showDescription: description,
      showLocalization: localization,
      cotaMin: minQuota,
      cotaMax: maxQuota,
    };

    setIsloading(true);

    await changeConfigQuota({
      jwt: jwt,
      data: data,
      id: idConfigQuota,
      type: typeRequets,
    }).then((res) => {
      setIsloading(false);
      if (res.message === "created" || res.message === "updated") {
        setSuccess(true);
      }
    });
  }

  async function getConfigQuotaFunc() {
    await getConfigQuota(jwt, eventId).then((res) => {
      if (res.message === "findAllConfigs" && res.findAll.count > 0) {
        const dataConfig = res.findAll.data[0];

        setImgUrl(dataConfig.image);
        setColor(dataConfig.color);
        setDescription(dataConfig.showDescription);
        setLocalization(dataConfig.showLocalization);
        setIdConfigQuota(dataConfig.id);
        setMinQuota(dataConfig.cotaMin ? dataConfig.cotaMin : 1);
        setMaxQuota(dataConfig.cotaMax ? dataConfig.cotaMax : 4);
        setTypeRequets("put");
      }
    });
    // .catch((error) => console.log("error quota", error));

    setLoadingForm(false);
  }

  useEffect(() => {
    getConfigQuotaFunc();
  }, []);

  useEffect(() => {
    if (minQuota > maxQuota) {
      setMinQuota(maxQuota);
    }
  }, [minQuota, maxQuota]);

  return (
    <>
      {success ? (
        <SweetAlert
          success
          title={"Concluído"}
          onConfirm={() => {
            toggle();
          }}
        >
          {"Configurações salvas com sucesso!"}
        </SweetAlert>
      ) : null}
      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Configurar Site Cotas</ModalHeader>
        <ModalBody>
          {loadingForm ? (
            <p style={{ textAlign: "center" }}>Carregando ...</p>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitForm();
              }}
            >
              <Row>
                <Col md={!img && imgUrl ? 6 : 12}>
                  <div>
                    <Label htmlFor="formFile" className="form-label">
                      Imagem do Evento*
                    </Label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile"
                      onChange={(e) => setImg(e)}
                    />
                    {imgError && <a style={{ color: "red" }}>{imgError}</a>}
                  </div>
                </Col>

                {!img && imgUrl && (
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <img src={imgUrl} style={{ width: 100, height: 100 }} />
                      <i
                        className="mdi mdi-trash-can icon-trash"
                        onClick={() => setImgUrl(null)}
                      />
                    </div>
                  </Col>
                )}
              </Row>

              <Row>
                <ColorPicker
                  classOfContainer="bg-new-event-menu-pickr"
                  labelText="Cor do Evento"
                  setStateFunc={setColor}
                  defaultColor={color}
                />
              </Row>

              <Row style={{ marginTop: 15 }}>
                <Col md={6}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="checkDescription"
                      onChange={(e) => setDescription(e.target.checked)}
                      defaultChecked={description}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkDescription"
                    >
                      Exibir Descrição
                    </label>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="checkLocalization"
                      onChange={(e) => setLocalization(e.target.checked)}
                      defaultChecked={localization}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkLocalization"
                    >
                      Exibir Localização
                    </label>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginTop: 15 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">
                      Quantidade de cotas por participante*
                    </label>
                    <div className="div-select-in-range">
                      <input
                        className="form-control"
                        type="number"
                        value={minQuota}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          var valueSet = 1;
                          if (value < 1) {
                            valueSet = 1;
                          } else if (value > 4) {
                            valueSet = 4;
                          } else valueSet = value;

                          setMinQuota(valueSet);
                        }}
                      />
                      <a style={{ margin: "0 10px" }}>até</a>
                      <input
                        className="form-control"
                        type="number"
                        value={maxQuota}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          var valueSet = 1;
                          if (value < 1) {
                            valueSet = 1;
                          } else if (value > 4) {
                            valueSet = 4;
                          } else valueSet = value;

                          setMaxQuota(valueSet);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row
                style={{
                  marginTop: 20,
                }}
              >
                <Col
                  lg={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    color="danger"
                    style={{ width: 80, marginRight: 10 }}
                    onClick={() => toggle()}
                  >
                    Fechar
                  </Button>

                  <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
                </Col>
              </Row>
            </form>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}
